import { RootState } from "../../../store";

export const userProfileSelector = (state: RootState) => {
    return state.userProfile.profile.user;
};
export const loadingUserProfileSelector = (state: RootState) => {
    return state.userProfile.loadingUser;
};
